export default "__VITE_ASSET__CCzTSMX9__"